import Orders from './orders'

const OrdersPage = () => {
  return <Orders url='/orders/monograms' />
}

export default OrdersPage;
